const NEW_AUTH_NAMESPACE = 'oauth2'

/**
 * Default options for the auth module.
 * @type {import('./types').OauthModuleOptions}
 */
export const AUTH_CONFIG = {
  clientId: '',
  domainBaseUrl: '',
  redirectPath: '/auth/login',
  storage: {
    prefix: `${NEW_AUTH_NAMESPACE}.`,
  },
}
